// before 20-5-2026

// import React, { useEffect } from 'react';
// import { Container, Table } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetCampainReportsData } from '../Redux/Actions/Campaign_Actions';
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   Legend,
//   Area,
//   AreaChart,
//   LabelList,
// } from 'recharts';

// export const CampaignsReports = () => {
//   const dispatch = useDispatch();

//   const getdata = async () => {
//     await dispatch(GetCampainReportsData());
//   };

//   useEffect(() => {
//     getdata();
//   }, []);

//   const resalldata = useSelector((state) => state.AllCampaign.campaign);
//   // console.log(resalldata, "resalldata in CampaignsReports");

//   return (
//     <Container className="startpage py-4">
//       <h2 className="text-center mb-4" style={{ color: '#102dff' }}>
//         Campaigns Report by Stages 📊
//       </h2>

//       {resalldata && resalldata?.data && resalldata?.data?.length > 0 ? (
//         <>
//           <Table striped bordered hover responsive>
//             <thead>
//               <tr>
//                 <th style={{ color: '#666' }}>Stage</th>
//                 <th style={{ color: '#666' }}>Campaign</th>
//                 <th style={{ color: '#666' }}>Leads Count</th>
//               </tr>
//             </thead>
//             <tbody>
//               {resalldata?.data?.map((stage) =>
//                 stage?.campaigns?.map((campaign, index) => (
//                   <tr key={`${stage?.stageId}-${campaign?.campaignId}`}>
//                     {index === 0 && (
//                       <td
//                         rowSpan={stage?.campaigns?.length}
//                         className="align-middle fw-bold text-primary"
//                       >
//                         {stage?.stageName}
//                       </td>
//                     )}
//                     <td>{campaign?.campaignName}</td>
//                     <td>{campaign?.leadsCount}</td>
//                   </tr>
//                 )),
//               )}
//             </tbody>
//           </Table>

//           <h4 className="mt-5 mb-3 text-center" style={{ color: '#102dff' }}>
//             Visualization of Each Campaign
//           </h4>

//           {(() => {
//             // بناء البيانات لكل حملة بشكل منفصل
//             const campaignsMap = {};

//             resalldata?.data?.forEach((stage) => {
//               stage?.campaigns?.forEach((campaign) => {
//                 if (!campaignsMap[campaign.campaignId]) {
//                   campaignsMap[campaign.campaignId] = {
//                     campaignName: campaign.campaignName,
//                     data: [],
//                   };
//                 }
//                 campaignsMap[campaign.campaignId].data.push({
//                   stage: stage.stageName,
//                   leadsCount: campaign.leadsCount,
//                 });
//               });
//             });

//             return Object.entries(campaignsMap).map(([campaignId, campaignData]) => (
//               <div key={campaignId} className="my-5">
//                 <h5 className="text-center mb-3" style={{ color: '#666' }}>
//                   {campaignData.campaignName}
//                 </h5>
//                 <ResponsiveContainer width="100%" height={350}>
//                   <AreaChart
//                     data={campaignData.data}
//                     margin={{ top: 20, right: 30, left: 0, bottom: 50 }}
//                   >
//                     <defs>
//                       <linearGradient id={`colorLeads-${campaignId}`} x1="0" y1="0" x2="0" y2="1">
//                         <stop offset="5%" stopColor="#0d6efd" stopOpacity={0.8} />
//                         <stop offset="95%" stopColor="#0d6efd" stopOpacity={0} />
//                       </linearGradient>
//                     </defs>
//                     <XAxis dataKey="stage" angle={-30} textAnchor="end" interval={0} height={80} />
//                     <YAxis />
//                     <Tooltip />
//                     <Area
//                       type="monotone"
//                       dataKey="leadsCount"
//                       stroke="#0d6efd"
//                       fillOpacity={1}
//                       fill={`url(#colorLeads-${campaignId})`}
//                       name="Leads Count"
//                     >
//                       <LabelList
//                         dataKey="leadsCount"
//                         content={(props) => {
//                           const { x, y, value, payload } = props;
//                           return (
//                             <text x={x} y={y - 10} fill="#333" fontSize={12} textAnchor="middle">
//                               {`${payload?.stage}: ${value}`}
//                             </text>
//                           );
//                         }}
//                       />
//                     </Area>
//                   </AreaChart>
//                 </ResponsiveContainer>
//               </div>
//             ));
//           })()}
//         </>
//       ) : (
//         <div className="text-center text-muted py-5">No data available for campaigns report 🚫</div>
//       )}
//     </Container>
//   );
// };


















import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetCampainReportsData } from '../Redux/Actions/Campaign_Actions';
import { useTheme } from '@mui/material';
import { useSidebarWidth } from '../Utility/useSidebarWidth';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
  CartesianGrid, Cell, Legend,
} from 'recharts';

/* ── tokens ────────────────────────────────────────────────────── */
const ACCENT   = '#0D47A1';
const COLORS   = ['#0D47A1','#10B981','#F59E0B','#EF4444','#8B5CF6','#06B6D4','#EC4899','#84CC16','#F97316','#6366F1'];

/* ── Custom Tooltip ─────────────────────────────────────────────── */
const CustomTooltip = ({ active, payload, label, dark, allCampaigns }) => {
  if (!active || !payload?.length) return null;

  const stageName = label;
  const surface   = dark ? '#1E1E2E' : '#fff';
  const border    = dark ? 'rgba(255,255,255,0.10)' : '#E8EAF0';
  const textPri   = dark ? '#E2E8F0' : '#1C2340';
  const textSec   = dark ? '#94A3B8' : '#7B829A';

  return (
    <div style={{
      background: surface, border: `1px solid ${border}`,
      borderRadius: 16, padding: '16px 20px',
      boxShadow: '0 12px 40px rgba(0,0,0,0.16)',
      fontFamily: "'DM Sans', sans-serif",
      minWidth: 220, maxWidth: 280,
    }}>
      {/* Stage title */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, paddingBottom: 10, borderBottom: `1px solid ${border}` }}>
        <div style={{ width: 8, height: 8, borderRadius: '50%', background: ACCENT }} />
        <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: textPri }}>{stageName}</p>
      </div>

      {/* Each campaign value */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {payload.map((entry, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
              <div style={{ width: 10, height: 10, borderRadius: 3, background: entry.color, flexShrink: 0 }} />
              <span style={{ fontSize: 12, color: textSec, maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{entry.name}</span>
            </div>
            <span style={{ fontSize: 14, fontWeight: 700, color: textPri }}>{entry.value?.toLocaleString()}</span>
          </div>
        ))}
      </div>

      {/* Total row */}
      {payload.length > 1 && (
        <div style={{ marginTop: 10, paddingTop: 10, borderTop: `1px solid ${border}`, display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: textSec }}>Total</span>
          <span style={{ fontSize: 14, fontWeight: 800, color: ACCENT }}>{payload.reduce((acc, p) => acc + (p.value || 0), 0).toLocaleString()}</span>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════════════════════════════════ */
export const CampaignsReports = () => {
  const dispatch     = useDispatch();
  const theme        = useTheme();
  const dark         = theme.palette.mode === 'dark';
  const sidebarWidth = useSidebarWidth();

  /* tokens */
  const bg      = dark ? '#0f1117' : '#F7F8FC';
  const surface = dark ? '#1E1E2E' : '#FFFFFF';
  const border  = dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0';
  const textPri = dark ? '#E2E8F0' : '#1C2340';
  const textSec = dark ? '#94A3B8' : '#7B829A';
  const inputBg = dark ? '#2A2A3E' : '#F7F8FC';

  const [selectedIds, setSelectedIds] = useState([]);   // [] = show all
  const [search,      setSearch]      = useState('');
  const [dropOpen,    setDropOpen]    = useState(false);
  const dropRef = useRef(null);

  useEffect(() => { dispatch(GetCampainReportsData()); }, []);

  /* close dropdown on outside click */
  useEffect(() => {
    const h = (e) => { if (dropRef.current && !dropRef.current.contains(e.target)) setDropOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const resalldata = useSelector(s => s.AllCampaign.campaign);
  const rawData    = resalldata?.data || [];

  /* ── build campaigns map ── */
  const campaignsMap = {};
  rawData.forEach(stage => {
    stage?.campaigns?.forEach(c => {
      if (!campaignsMap[c.campaignId]) campaignsMap[c.campaignId] = { id: c.campaignId, name: c.campaignName, total: 0 };
      campaignsMap[c.campaignId].total += c.leadsCount;
    });
  });
  const allCampaigns = Object.values(campaignsMap).sort((a, b) => b.total - a.total);
  const filtered     = search ? allCampaigns.filter(c => c.name.toLowerCase().includes(search.toLowerCase())) : allCampaigns;

  /* which campaigns to show in chart */
  const activeCampaigns = selectedIds.length > 0
    ? allCampaigns.filter(c => selectedIds.includes(c.id))
    : allCampaigns;

  /* ── build chart data (stages as X axis) ── */
  const chartData = rawData.map(stage => {
    const row = { stage: stage.stageName, _stageTotal: 0 };
    activeCampaigns.forEach(ac => {
      const found = stage.campaigns?.find(c => c.campaignId === ac.id);
      const val   = found?.leadsCount || 0;
      row[ac.id]    = val;
      row._stageTotal += val;
    });
    return row;
  });

  /* ── grand total ── */
  const grandTotal = activeCampaigns.reduce((acc, c) => acc + c.total, 0);

  /* ── toggle campaign selection ── */
  const toggleCampaign = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  const clearAll  = () => setSelectedIds([]);
  const selectAll = () => setSelectedIds(allCampaigns.map(c => c.id));

  /* ── selected label ── */
  const selectorLabel = selectedIds.length === 0
    ? 'All Campaigns'
    : selectedIds.length === 1
    ? allCampaigns.find(c => c.id === selectedIds[0])?.name || '1 selected'
    : `${selectedIds.length} campaigns selected`;

  if (!rawData.length) return (
    <div style={{
      position: 'fixed', top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      gap: 12, background: bg, fontFamily: "'DM Sans',sans-serif",
    }}>
      <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke={textSec} strokeWidth="1.3"><path d="M3 3v18h18"/><path d="M7 16l4-4 4 4 4-4"/></svg>
      <p style={{ fontSize: 15, color: textSec, margin: 0 }}>No campaign data available</p>
    </div>
  );

  return (
    <div style={{
      position: 'fixed',
      top: '50px',
      left: sidebarWidth,
      right: 0,
      bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      overflowX: 'hidden',
      background: bg,
      fontFamily: "'DM Sans',sans-serif",
    }}>
    <div style={{ padding: '36px 28px 64px' }}>

      {/* ── Page header ── */}
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: textPri, letterSpacing: '-0.5px' }}>
          Campaigns Report
        </h1>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: textSec }}>
          {allCampaigns.length} campaigns · {rawData.length} stages tracked
        </p>
      </div>

      {/* ── Top bar: selector + stats ── */}
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-start', marginBottom: 28 }}>

        {/* ── Campaign Multi-Select ── */}
        <div ref={dropRef} style={{ position: 'relative', flex: '0 0 320px', minWidth: 240 }}>
          <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: textSec, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 6 }}>Filter Campaigns</label>
          <button
            onClick={() => setDropOpen(p => !p)}
            style={{
              width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              gap: 10, padding: '10px 14px',
              background: surface, border: `1px solid ${dropOpen ? ACCENT : border}`,
              borderRadius: 12, cursor: 'pointer', fontFamily: "'DM Sans',sans-serif",
              fontSize: 13, fontWeight: 600, color: textPri,
              boxShadow: dropOpen ? `0 0 0 3px rgba(13,71,161,0.12)` : 'none',
              transition: 'all 0.15s',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{ width: 8, height: 8, borderRadius: '50%', background: selectedIds.length > 0 ? ACCENT : '#10B981' }} />
              <span style={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {selectorLabel}
              </span>
            </div>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={textSec} strokeWidth="2.5"
              style={{ transform: dropOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', flexShrink: 0 }}>
              <path d="M6 9l6 6 6-6"/>
            </svg>
          </button>

          {/* dropdown */}
          {dropOpen && (
            <div style={{
              position: 'absolute', top: 'calc(100% + 6px)', left: 0, width: '100%',
              background: surface, border: `1px solid ${border}`, borderRadius: 14,
              boxShadow: '0 16px 40px rgba(0,0,0,0.14)', zIndex: 1000, overflow: 'hidden',
            }}>
              {/* search inside dropdown */}
              <div style={{ padding: '10px 12px', borderBottom: `1px solid ${border}` }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: inputBg, borderRadius: 8, padding: '7px 12px' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={textSec} strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                  <input
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    placeholder="Search campaigns..."
                    autoFocus
                    style={{ border: 'none', background: 'transparent', outline: 'none', fontSize: 13, color: textPri, width: '100%', fontFamily: "'DM Sans',sans-serif" }}
                  />
                </div>
              </div>

              {/* select all / clear */}
              <div style={{ padding: '8px 12px', borderBottom: `1px solid ${border}`, display: 'flex', gap: 8 }}>
                <button onClick={selectAll} style={{ fontSize: 11, fontWeight: 600, color: ACCENT, background: 'rgba(13,71,161,0.08)', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" }}>Select All</button>
                <button onClick={clearAll}  style={{ fontSize: 11, fontWeight: 600, color: textSec, background: 'transparent', border: `1px solid ${border}`, borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" }}>Clear</button>
              </div>

              {/* list */}
              <div style={{ maxHeight: 280, overflowY: 'auto' }}>
                {filtered.length === 0 && (
                  <p style={{ margin: 0, padding: '16px 14px', fontSize: 13, color: textSec, textAlign: 'center' }}>No campaigns found</p>
                )}
                {filtered.map((c, i) => {
                  const sel = selectedIds.includes(c.id);
                  return (
                    <div key={c.id}
                      onClick={() => toggleCampaign(c.id)}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 10,
                        padding: '10px 14px', cursor: 'pointer',
                        background: sel ? 'rgba(13,71,161,0.06)' : 'transparent',
                        borderBottom: `1px solid ${border}`,
                        transition: 'background 0.12s',
                      }}
                      onMouseEnter={e => { if (!sel) e.currentTarget.style.background = dark ? 'rgba(255,255,255,0.04)' : '#F7F8FC'; }}
                      onMouseLeave={e => { if (!sel) e.currentTarget.style.background = 'transparent'; }}
                    >
                      {/* color dot */}
                      <div style={{ width: 10, height: 10, borderRadius: 3, background: COLORS[i % COLORS.length], flexShrink: 0 }} />

                      {/* checkbox */}
                      <div style={{
                        width: 16, height: 16, borderRadius: 4,
                        border: `2px solid ${sel ? ACCENT : border}`,
                        background: sel ? ACCENT : 'transparent',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'all 0.12s',
                      }}>
                        {sel && <svg width="9" height="9" viewBox="0 0 12 10" fill="none"><path d="M1 5l3.5 3.5L11 1" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                      </div>

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ margin: 0, fontSize: 13, fontWeight: sel ? 600 : 400, color: sel ? textPri : textSec, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.name}</p>
                      </div>
                      <span style={{ fontSize: 12, fontWeight: 700, color: sel ? ACCENT : textSec, flexShrink: 0 }}>{c.total.toLocaleString()}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* ── quick stats ── */}
        <div style={{ display: 'flex', gap: 12, flex: 1, flexWrap: 'wrap' }}>
          {[
            { label: 'Showing', val: activeCampaigns.length, sub: 'campaigns' },
            { label: 'Total Leads', val: grandTotal.toLocaleString(), highlight: true },
            { label: 'Avg / Campaign', val: activeCampaigns.length > 0 ? Math.round(grandTotal / activeCampaigns.length).toLocaleString() : '—', sub: 'leads' },
          ].map(({ label, val, sub, highlight }) => (
            <div key={label} style={{
              background: highlight ? ACCENT : surface,
              border: `1px solid ${highlight ? ACCENT : border}`,
              borderRadius: 14, padding: '16px 22px', flex: 1, minWidth: 130,
              boxShadow: highlight ? '0 4px 20px rgba(13,71,161,0.25)' : '0 1px 3px rgba(16,24,40,0.08)',
            }}>
              <p style={{ margin: 0, fontSize: 10, fontWeight: 600, letterSpacing: '0.07em', textTransform: 'uppercase', color: highlight ? 'rgba(255,255,255,0.7)' : textSec }}>{label}</p>
              <p style={{ margin: '6px 0 2px', fontSize: 26, fontWeight: 800, color: highlight ? '#fff' : textPri, lineHeight: 1, letterSpacing: '-0.5px' }}>{val}</p>
              {sub && <p style={{ margin: 0, fontSize: 11, color: highlight ? 'rgba(255,255,255,0.55)' : textSec }}>{sub}</p>}
            </div>
          ))}
        </div>
      </div>

      {/* ── Active campaign chips ── */}
      {selectedIds.length > 0 && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 20 }}>
          {activeCampaigns.map((c, i) => (
            <div key={c.id} style={{
              display: 'flex', alignItems: 'center', gap: 7,
              padding: '5px 12px', borderRadius: 20,
              background: `${COLORS[i % COLORS.length]}18`,
              border: `1px solid ${COLORS[i % COLORS.length]}40`,
              fontSize: 12, fontWeight: 600, color: COLORS[i % COLORS.length],
              cursor: 'pointer',
            }}
              onClick={() => toggleCampaign(c.id)}
            >
              <div style={{ width: 8, height: 8, borderRadius: '50%', background: COLORS[i % COLORS.length] }} />
              {c.name.length > 24 ? c.name.slice(0, 22) + '…' : c.name}
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </div>
          ))}
          <div onClick={clearAll} style={{ padding: '5px 12px', borderRadius: 20, border: `1px solid ${border}`, fontSize: 12, fontWeight: 600, color: textSec, cursor: 'pointer' }}>
            Clear all
          </div>
        </div>
      )}

      {/* ── Main Chart ── */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 20, padding: '28px 24px 20px', boxShadow: '0 1px 3px rgba(16,24,40,0.08)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
          <div>
            <p style={{ margin: 0, fontSize: 16, fontWeight: 700, color: textPri }}>Leads per Stage</p>
            <p style={{ margin: '3px 0 0', fontSize: 12, color: textSec }}>Hover any bar for details · {rawData.length} stages</p>
          </div>
          {/* legend */}
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            {activeCampaigns.slice(0, 6).map((c, i) => (
              <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                <div style={{ width: 10, height: 10, borderRadius: 3, background: COLORS[i % COLORS.length] }} />
                <span style={{ fontSize: 11, color: textSec, maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.name}</span>
              </div>
            ))}
            {activeCampaigns.length > 6 && <span style={{ fontSize: 11, color: textSec }}>+{activeCampaigns.length - 6} more</span>}
          </div>
        </div>

        <ResponsiveContainer width="100%" height={380}>
          <BarChart data={chartData} margin={{ top: 10, right: 10, left: -10, bottom: 60 }} barGap={2} barCategoryGap="30%">
            <CartesianGrid strokeDasharray="3 3" stroke={dark ? 'rgba(255,255,255,0.05)' : '#F0F2F8'} vertical={false} />
            <XAxis
              dataKey="stage"
              tick={{ fontSize: 11, fill: textSec, fontFamily: "'DM Sans',sans-serif" }}
              angle={-30} textAnchor="end" interval={0} height={70}
              axisLine={false} tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 11, fill: textSec, fontFamily: "'DM Sans',sans-serif" }}
              axisLine={false} tickLine={false}
            />
            <Tooltip
              content={<CustomTooltip dark={dark} allCampaigns={activeCampaigns} />}
              cursor={{ fill: dark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)', radius: 8 }}
            />
            {activeCampaigns.map((c, i) => (
              <Bar key={c.id} dataKey={c.id} name={c.name}
                fill={COLORS[i % COLORS.length]}
                radius={[5, 5, 0, 0]}
                maxBarSize={28}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* ── Campaign detail table ── */}
      <div style={{ marginTop: 24, background: surface, border: `1px solid ${border}`, borderRadius: 20, overflow: 'hidden', boxShadow: '0 1px 3px rgba(16,24,40,0.08)' }}>
        <div style={{ padding: '18px 24px', borderBottom: `1px solid ${border}` }}>
          <p style={{ margin: 0, fontSize: 15, fontWeight: 700, color: textPri }}>Stage Breakdown Table</p>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: dark ? 'rgba(255,255,255,0.03)' : '#F7F8FC' }}>
                <th style={{ padding: '10px 20px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: textSec, letterSpacing: '0.07em', textTransform: 'uppercase', borderBottom: `1px solid ${border}`, whiteSpace: 'nowrap' }}>Stage</th>
                {activeCampaigns.map((c, i) => (
                  <th key={c.id} style={{ padding: '10px 16px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: COLORS[i % COLORS.length], letterSpacing: '0.06em', textTransform: 'uppercase', borderBottom: `1px solid ${border}`, whiteSpace: 'nowrap', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {c.name.length > 16 ? c.name.slice(0, 14) + '…' : c.name}
                  </th>
                ))}
                <th style={{ padding: '10px 16px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: textSec, letterSpacing: '0.07em', textTransform: 'uppercase', borderBottom: `1px solid ${border}` }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {chartData.map((row, ri) => (
                <tr key={ri}
                  style={{ borderBottom: `1px solid ${border}`, transition: 'background 0.12s' }}
                  onMouseEnter={e => e.currentTarget.style.background = dark ? 'rgba(255,255,255,0.03)' : '#F9FAFC'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <td style={{ padding: '12px 20px', fontSize: 13, fontWeight: 600, color: textPri, whiteSpace: 'nowrap' }}>{row.stage}</td>
                  {activeCampaigns.map((c, i) => (
                    <td key={c.id} style={{ padding: '12px 16px', textAlign: 'right', fontSize: 13, fontWeight: row[c.id] > 0 ? 700 : 400, color: row[c.id] > 0 ? COLORS[i % COLORS.length] : textSec }}>
                      {row[c.id] > 0 ? row[c.id].toLocaleString() : '—'}
                    </td>
                  ))}
                  <td style={{ padding: '12px 16px', textAlign: 'right', fontSize: 14, fontWeight: 800, color: textPri }}>{row._stageTotal.toLocaleString()}</td>
                </tr>
              ))}
              {/* totals row */}
              <tr style={{ background: dark ? 'rgba(13,71,161,0.12)' : 'rgba(13,71,161,0.05)', borderTop: `2px solid ${ACCENT}30` }}>
                <td style={{ padding: '12px 20px', fontSize: 12, fontWeight: 700, color: ACCENT, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Total</td>
                {activeCampaigns.map((c, i) => (
                  <td key={c.id} style={{ padding: '12px 16px', textAlign: 'right', fontSize: 14, fontWeight: 800, color: COLORS[i % COLORS.length] }}>{c.total.toLocaleString()}</td>
                ))}
                <td style={{ padding: '12px 16px', textAlign: 'right', fontSize: 16, fontWeight: 800, color: ACCENT }}>{grandTotal.toLocaleString()}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
    </div>
  );
};
